import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestCategoryService } from "../services/requestCategory.service";

export const useDeleteRequestCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (categoryId: string) => requestCategoryService.deleteRequestCategory(categoryId),
    onSuccess: () => {
      // Invalidate request categories query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["requestCategories"] });
    },
  });
};
